import { useEffect, useState } from 'react';
import { websiteClient } from '../services/website/WebsiteClient';
import { DeliveryInfoResponse } from '../services/website/types';

interface State {
  readonly deliveryInfo: DeliveryInfoResponse;
  readonly error: boolean;
  readonly loading: boolean;
}

const initialState: State = {
  deliveryInfo: [],
  error: false,
  loading: true
};

export const useDeliveryInfo = (postalCode?: number, customerNumber?: number) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (postalCode && customerNumber) {
      websiteClient
        .getDeliveryInfo(postalCode, customerNumber)
        .then((response) => {
          setState({ deliveryInfo: response, loading: false, error: false });
        })
        .catch((err) => {
          setState({ deliveryInfo: [], loading: false, error: true });
        });
    }
  }, [postalCode, customerNumber]);

  return state;
};
